import React from "react";
import Card from "../ui/Card";
import Stat from "../ui/Stat";
import Progress from "../ui/Progress";

const steps = [
  { title: "1. Welcome & Login", detail: "Introduce Nia COACH, log in, and set a role for the walkthrough." },
  { title: "2. Home Dashboard", detail: "Show engagement pulse, quick actions, and recent sessions." },
  { title: "3. Live Coaching", detail: "Open Chat, send a prompt, and highlight session toolkit." },
  { title: "4. Org Insights", detail: "Review KPI tiles, sentiment mix, and seat usage." },
  { title: "5. Games Showcase", detail: "Preview cognitive training titles and positioning." },
];

export default function DemoWalkthrough() {
  return (
    <div className="nia-page">
      <Card className="nia-hero">
        <div className="nia-header">
          <div>
            <h2>Investor Demo Walkthrough</h2>
            <p>A short, confident flow to showcase Nia COACH’s coaching intelligence and enterprise readiness.</p>
          </div>
          <div className="nia-pill">10–12 minutes</div>
        </div>
      </Card>

      <div className="nia-grid nia-grid--3">
        <Stat label="Demo Stages" value="5" subtle="Narrated moments" />
        <Stat label="Audience" value="Investors" subtle="Board-level clarity" />
        <Stat label="Outcome" value="Signal Strength" subtle="Product + traction" />
      </div>

      <Card title="Walkthrough Flow">
        <div className="nia-list">
          {steps.map((step) => (
            <div key={step.title} className="nia-list-btn">
              <div>
                <div style={{ fontWeight: 600 }}>{step.title}</div>
                <div className="nia-muted" style={{ marginTop: 4 }}>{step.detail}</div>
              </div>
              <span className="nia-pill">Ready</span>
            </div>
          ))}
        </div>
      </Card>

      <div className="nia-grid nia-grid--2">
        <Card title="Suggested Script">
          <div className="nia-muted">
            Nia COACH blends real-time coaching with organizational intelligence. We move from individual sessions
            to executive insights without leaving the product. The UI is designed to be calm, precise, and
            enterprise-ready.
          </div>
        </Card>
        <Card title="Demo Readiness">
          <Progress value={92} />
          <div className="nia-muted" style={{ marginTop: 8 }}>
            Only refresh data if you want a clean history before presenting.
          </div>
        </Card>
      </div>
    </div>
  );
}
